/**
 * Settings module translations - Modals section
 */

const modals = {
  addKsefTokenTitle: "Añadir token KSeF",
  manageKsefTokenTitle: "Gestionar token KSeF",
  ksefReplaceWarning: "El token anterior será reemplazado",
  ksefTokenRequired: "El token KSeF es obligatorio",
  removeKsefTokenConfirm:
    "¿Eliminar el token KSeF guardado? Podrá añadir uno nuevo más tarde.",
  deleteKsefTokenTitle: "Eliminar token KSeF",
  deleteKsefTokenDescription:
    "¿Está seguro de que desea eliminar el token KSeF guardado? Podrá añadir uno nuevo más tarde.",
  deleteBankTitle: "¿Eliminar banco?",
  deleteBankDescription: "¿Está seguro de que desea eliminar el banco \"{{bankName}}\"?",
  editProduct: "Editar producto",
  addProduct: "Agregar producto",
  deleteProductTitle: "Eliminar producto",
  deleteProductDescription: "¿Está seguro de que desea eliminar \"{{productName}}\"?",
  errorAddingProduct: "Error al agregar producto",
  errorUpdatingProduct: "Error al actualizar producto",
  errorDeletingProduct: "Error al eliminar producto"
};

export default modals;
